import React from 'react';
import { BsBoxSeam } from 'react-icons/bs';
import { useCustomer } from './CustomerContext';
import EmptyState from './components/EmptyState';
import { formatDate, formatEur } from '../../utils/api';

const CustomerServicesPage = () => {
  const { services, loading } = useCustomer();

  if (loading) {
    return (
      <div>
        <div className="cp-skeleton cp-skeleton-title" />
        <div className="cp-skeleton cp-skeleton-card" style={{ height: 260 }} />
      </div>
    );
  }

  const list = Array.isArray(services) ? services : [];

  return (
    <div>
      <h1 className="cp-page-title">Servicios contratados</h1>

      {!list.length ? (
        <EmptyState icon={BsBoxSeam} title="Sin servicios contratados" subtitle="Aún no tienes servicios recurrentes contratados (dominios, alojamiento, mantenimiento…)." />
      ) : (
        <div className="cp-card-static">
          <div style={{ overflowX: 'auto' }}>
            <table className="cp-table">
              <thead>
                <tr>
                  <th>Servicio</th>
                  <th>Periodicidad</th>
                  <th>Próxima renovación</th>
                  <th style={{ textAlign: 'right' }}>Precio</th>
                </tr>
              </thead>
              <tbody>
                {list.map((s, i) => (
                  <tr key={i}>
                    <td style={{ fontWeight: 500 }}>{s.concepto || '-'}</td>
                    <td>{s.periodicidad || '-'}</td>
                    <td>{s.proxima_renovacion ? formatDate(s.proxima_renovacion) : '-'}</td>
                    <td style={{ textAlign: 'right' }}>{formatEur(s.precio)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerServicesPage;
